<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Conversión de Divisas</h4>
        <b-card class="mt-md-4 bg-none" body-class="px-0">
            <b-form>
                <b-row align-h="center">
                    <b-col cols="12" md="10">
                        <h5 class="text-center mb-2">{{ labels.country }}</h5>
                    </b-col>
                    <b-col cols="12" sm="10" md="6" lg="5" align-self="start">
                        <b-form-group>
                            <b-form-select name="country" :options="countries" :disabled="loading"
                                v-model="form.country" class="form-control select-center mb-4"
                                size="lg"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="10" md="6" lg="5" align-self="start">
                        <b-form-group>
                            <b-form-radio-group v-model="form.payReceiver" :options="payReceivers" :disabled="loading"
                                button-variant="outline-primary" class="btn-block align-baseline mb-4" size="lg"
                                name="payReceiver" buttons></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="12" md="10">
                        <h5 class="text-center mb-2">{{ payReceiverLabel }}</h5>
                    </b-col>
                    <b-col cols="12" md="10" align-self="start" v-if="form.payReceiver === 'Cash'">
                        <b-form-group>
                            <v-select :options="offices" v-model="officeSelected" :searchable="true" :disabled="loading"
                                class="mb-4 h-auto" labelTitle="-- Por favor seleccione una oficina --"
                                labelNotFound="La oficina no existe" labelSearchPlaceholder="Buscar Oficina"
                                textProp="name" />
                            <b-form-select v-show="false" name="office" :options="offices" :value="form.office"
                                v-model="form.office" class="form-control select-center" :disabled="loading"
                                value-field="code" text-field="name">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="10" align-self="start" v-if="form.payReceiver === 'Bank'">
                        <b-form-group>
                            <v-select :options="banks" v-model="bankSelected" :searchable="true" :disabled="loading"
                                class="mb-4 h-auto" labelTitle="-- Por favor seleccione un banco --"
                                labelNotFound="El banco no existe" labelSearchPlaceholder="Buscar banco"
                                textProp="name" />
                            <b-form-select v-show="false" name="bank" :options="banks" :value="form.bank"
                                v-model="form.bank" text-field="name" value-field="code"
                                class="form-control select-center" :disabled="loading"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="10" align-self="start" v-if="form.payReceiver === 'Wallet'">
                        <b-form-group>
                            <v-select :options="wallets" v-model="walletSelected" :searchable="true" :disabled="loading"
                                class="mb-4 h-auto" labelTitle="-- Por favor seleccione una Wallet --"
                                labelNotFound="La wallet no existe" labelSearchPlaceholder="Buscar Wallet"
                                textProp="name" />
                            <b-form-select v-show="false" name="wallet" :options="wallets" :value="form.wallet"
                                v-model="form.wallet" text-field="name" value-field="code"
                                class="form-control select-center" :disabled="loading"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="12" md="10">
                        <h5 class="text-center my-2">{{ labels.send }}</h5>
                    </b-col>
                    <b-col cols="12" md="10">
                        <b-input-group>
                            <template #prepend>
                                <b-input-group-text
                                    class="m-0 px-lg-5 px-sm-4 btrr-0 bbrr-0"><b>$</b></b-input-group-text>
                            </template>
                            <currency-input v-model="form.vSend" :precision="pSend"
                                class="text-right text-sm-center form-control form-control-lg" :disabled="loading"
                                @keyup="getFx" />
                            <template #append>
                                <b-dropdown :text="form.cSend" variant="default" right class="m-0 btlr-0 bblr-0"
                                    toggle-class="px-lg-5 px-sm-4" :disabled="loading">
                                    <template v-for="item in cSend">
                                        <b-dropdown-item @click="form.cSend = item.code">{{ item.code + ' - ' +
                                            item.name }}</b-dropdown-item>
                                    </template>
                                </b-dropdown>
                            </template>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="12" md="10" class="py-3">
                        <b-skeleton-img no-aspect height="76px" v-if="loading"></b-skeleton-img>
                        <b-card bg-variant="default" class="p-2 text-center" body-class="p-0" v-else>
                            <template v-if="!msg">
                                <strong>Comisión:</strong> {{ Number(fee).toLocaleString('en-US',
                                    {
                                        minimumFractionDigits: (form.cSend === 'CLP' ? 0 : 2), maximumFractionDigits:
                                            (form.cSend === 'CLP' ? 0 : 2)
                                    }) }} {{ form.cSend }}<br>
                                <strong>Valor a Convertir:</strong> {{ Number(form.vSend - fee).toLocaleString('en-US',
                                    {
                                        minimumFractionDigits: (form.cSend === 'CLP' ? 0 : ((form.vSend - fee) % 1 == 0 ? 0 :
                                            2)), maximumFractionDigits: (form.cSend === 'CLP' ? 0 : ((form.vSend - fee) % 1 == 0 ? 0
                                                : 2))
                                    }) }} {{ form.cSend }}<br>
                                <strong>Tipo de Cambio:</strong>
                                <template v-if="quotingTerrapay">
                                    Cotizando...
                                </template>
                                <template v-else>
                                    {{ Number(form.convert < 1 ? (1 / form.convert) :
                                    1).toLocaleString('en-US', {
                                        minimumFractionDigits: (form.convert < 1 ?
                                            (form.convert % 1 == 0 ? 0 : 2) : 0), maximumFractionDigits: (form.convert < 1 ?
                                                (form.convert % 1 == 0 ? 0 : 2) : 0)
                                    }) }} {{ form.cSend }}={{ Number(form.convert < 1
                                        ? 1 : form.convert).toLocaleString('en-US', {
                                            minimumFractionDigits: (form.convert <
                                                1 ? 0 : (form.convert % 1 == 0 ? 0 : 2)), maximumFractionDigits: (form.convert < 1 ? 0
                                                    : (form.convert % 1 == 0 ? 0 : 2))
                                        }) }} {{ form.cReceiver }}
                                </template>
                                <br>
                            </template>
                            <template v-else>
                                <br><strong>El valor es {{ msg === 'maximo' ? 'mayor' : 'menor' }} al {{ msg }}
                                    permitido.</strong><br><br>
                            </template>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="12" md="10">
                        <h5 class="text-center my-2">{{ labels.receiver }}</h5>
                    </b-col>
                    <b-col cols="12" md="10">
                        <b-input-group>
                            <template #prepend>
                                <b-input-group-text class="m-0 px-lg-5 px-sm-4 btrr-0 bbrr-0"><b>{{ form.cReceiver ===
                                    'PEN' ? 'S/.' : (form.cReceiver === 'EUR' ? '€' : '$')
                                        }}</b></b-input-group-text>
                            </template>
                            <currency-input v-model="form.vReceiver" :disabled="loading" :precision="pReceiver"
                                class="text-right text-sm-center form-control form-control-lg" @keyup="getResult(1)" />
                            <template #append>
                                <b-dropdown :text="form.cReceiver" variant="default" right dropup
                                    class="m-0 btlr-0 bblr-0" toggle-class="px-lg-5 px-sm-4" :disabled="loading">
                                    <template v-for="item in cReceiver">
                                        <b-dropdown-item @click="form.cReceiver = item.code">{{ item.code + ' - ' +
                                            item.name }}</b-dropdown-item>
                                    </template>
                                </b-dropdown>
                            </template>
                        </b-input-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="12" md="10" class="py-3">
                        <b-skeleton-img no-aspect height="76px" v-if="loading"></b-skeleton-img>
                        <b-card bg-variant="default" class="p-2 text-center" body-class="p-0" v-else>
                            <strong>Monto Mínimo:</strong> {{ Number(min).toLocaleString('en-US') }} {{ form.cSend
                            }}<br>
                            <strong>Monto Máximo:</strong> {{ Number(max).toLocaleString('en-US') }} {{ form.cSend }}
                        </b-card>
                    </b-col>
                </b-row>
                <b-row align-h="center" align-content="center" v-if="$props.user">
                    <b-col cols="12" class="text-center">
                        <b-button v-if="user.role === 'Customer'"
                            :to="'/request?country=' + form.country + '&type=' + type + '&currency=' + (type === 'S' ? form.cSend : form.cReceiver) + '&value=' + (type === 'S' ? form.vSend : form.vReceiver)"
                            :disabled="msg !== null" class="my-md-4 my-2 px-5 py-2" variant="default" pill>
                            <i class="material-icons mdi mdi-send-circle"></i>&nbsp;
                            <span>{{ labels.request }}</span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-card>
    </b-container>
</template>

<script>
import axios from "axios";
import { CurrencyInput } from 'vue-currency-input';
import VSelect from '@alfsnd/vue-bootstrap-select'

export default {
    name: "Calculator",
    props: ['user'],
    components: {
        CurrencyInput,
        VSelect
    },
    data: () => ({
        server: '/moreg',
        labels: {
            country: 'DATOS DE DESTINO',
            office: 'OFICINA DE PAGO',
            bank: 'BANCO DE DESTINO',
            wallet: 'WALLET DE DESTINO',
            send: 'TU ENVIAS',
            receiver: 'TU DESTINATARIO RECIBE',
            request: 'ENVIAR AHORA'
        },
        form: {
            local: 'CL',
            country: 'PE',
            vSend: 0,
            cSend: 'CLP',
            convert: 0,
            vReceiver: 0,
            cReceiver: 'PEN',
            payReceiver: 'Bank',
            office: null,
            nOffice: null,
            bank: null,
            nBank: null,
            wallet: null,
            nWallet: null,
            payer_id: null,
            payer: null
        },
        collections: [],
        quoteTimeout: null,
        quotingTerrapay: false,
        payReceivers: [
            { text: 'Abono a Cta', value: 'Bank', disabled: false },
            { text: 'Ventanilla', value: 'Cash', disabled: false },
            { text: 'Wallet', value: 'Wallet', disabled: false }
        ],
        cSend: [
            { tm: 1, code: 'CLP', name: 'Pesos Chilenos' },
            { tm: 2, code: 'USD', name: 'Dolares' }
        ],
        cReceiver: [
            { tm: 1, code: 'COP', name: 'Pesos Colombianos' },
            { tm: 2, code: 'USD', name: 'Dolares' }
        ],
        countries: [
            { text: 'AR - Argentina', value: 'AR' },
            { text: 'BO - Bolivia', value: 'BO' },
            { text: 'BR - Brasil', value: 'BR' },
            { text: 'CO - Colombia', value: 'CO' },
            { text: 'DE - Alemania', value: 'DE' },
            { text: 'DO - Rep. Dominicana', value: 'DO' },
            { text: 'EC - Ecuador', value: 'EC' },
            { text: 'ES - España', value: 'ES' },
            { text: 'FR - Francia', value: 'FR' },
            { text: 'HT - Haiti', value: 'HT' },
            { text: 'IT - Italia', value: 'IT' },
            { text: 'PE - Perú', value: 'PE' },
            { text: 'US - Estados Unidos', value: 'US' },
            { text: 'VE - Venezuela', value: 'VE' }
        ],
        offices: [],
        officeSelected: null,
        banks: [],
        bankSelected: null,
        wallets: [],
        walletSelected: null,
        precision: 0,
        fee: 0,
        feeData: [],
        min: 0,
        minData: {},
        max: 0,
        maxData: {},
        loading: true,
        type: 'S',
        pSend: 0,
        pReceiver: 0,
        msg: null
    }),
    computed: {
        payReceiverLabel() {
            if (this.form.payReceiver === 'Cash') return this.labels.office;
            if (this.form.payReceiver === 'Wallet') return this.labels.wallet;
            return this.labels.bank;
        }
    },
    mounted() {
        this.server = '/moreg';
        this.form.country = this.$route.query.country || 'CO';
        this.$emit('loader');
        this.$emit('section', 'calculatorpage');
        if (!this.$route.query.country) {
            this.getIni();
        }
    },
    watch: {
        'user.partner'() {
            clearTimeout(this.timeout);
            this.getData();
        },
        'form.country'() {
            this.bankSelected = null;
            this.officeSelected = null;
            this.walletSelected = null;
            this.getIni();
        },
        'form.cSend'() {
            if (this.form.cSend === 'CLP') {
                this.pSend = 0;
            } else {
                this.pSend = 2;
            }
            this.getFx();
        },
        'form.cReceiver'() {
            if (!this.$route.query.country) {
                this.getFx();
            }
            this.$route.query.country = null;
            if (this.form.cReceiver === 'COP') {
                this.pReceiver = 0;
            } else {
                this.pReceiver = 2;
            }
            this.getResult(1);
        },
        'form.payReceiver'() {
            if (this.form.payReceiver === 'Cash' && (this.form.country === 'BR' || this.form.country === 'VE')) {
                this.form.payReceiver = 'Bank';
            }
            this.payReceivers[1].disabled = (this.form.country === 'BR' || this.form.country === 'VE');
            if (this.form.payReceiver === 'Cash') {
                this.bankSelected = null;
                this.walletSelected = null;
                this.officeSelected = this.offices[0];
            } else if (this.form.payReceiver === 'Bank') {
                this.officeSelected = null;
                this.walletSelected = null;
                this.bankSelected = this.banks[0];
            } else if (this.form.payReceiver === 'Wallet') {
                this.officeSelected = null;
                this.bankSelected = null;
                if (this.wallets.length > 0) {
                    this.walletSelected = this.wallets[0];
                }
            }
        },
        officeSelected() {
            if (this.officeSelected) {
                let offices = this.offices;

                for (let i = 0; i < offices.length; i++) {
                    if (offices[i] === this.officeSelected) {
                        this.form.office = offices[i].code;
                        this.form.nOffice = offices[i].name;
                        this.form.payer_id = offices[i].payer_id;
                        this.form.payer = offices[i].group;
                    }
                }
            } else {
                this.form.office = null;
                this.form.nOffice = null;
            }
        },
        bankSelected() {
            if (this.bankSelected) {
                let banks = this.banks;
                for (let i = 0; i < banks.length; i++) {
                    if (banks[i] === this.bankSelected) {
                        this.form.bank = banks[i].code;
                        this.form.nBank = banks[i].name;
                        this.form.payer_id = banks[i].payer_id;
                        this.form.payer = banks[i].group;
                    }
                }
            } else {
                this.form.bank = null;
                this.form.nBank = null;
            }
        },
        walletSelected() {
            if (this.walletSelected) {
                let wallets = this.wallets;
                for (let i = 0; i < wallets.length; i++) {
                    if (wallets[i] === this.walletSelected) {
                        this.form.wallet = wallets[i].code;
                        this.form.nWallet = wallets[i].name;
                        this.form.payer_id = wallets[i].payer_id;
                        this.form.payer = wallets[i].group;
                    }
                }
            } else {
                this.form.wallet = null;
                this.form.nWallet = null;
            }
        },
        'form.payer_id'() {
            this.getData();
        }
    },
    methods: {
        getRCurrency(n) {
            if (n > 1) {
                if (this.form.country === 'AR') {
                    this.cReceiver[0] = { tm: 1, code: 'ARS', name: 'Pesos Argentinos' };
                    this.form.cReceiver = 'ARS';
                } else if (this.form.country === 'BO') {
                    this.cReceiver[0] = { tm: 1, code: 'BOB', name: 'Bolivianos' };
                    this.form.cReceiver = 'BOB';
                } else if (this.form.country === 'BR') {
                    this.cReceiver[0] = { tm: 1, code: 'BRL', name: 'Reales' };
                    this.form.cReceiver = 'BRL';
                } else if (this.form.country === 'CO') {
                    this.cReceiver[0] = { tm: 1, code: 'COP', name: 'Pesos Colombianos' };
                    this.form.cReceiver = 'COP';
                } else if (this.form.country === 'HT') {
                    this.cReceiver[0] = { tm: 1, code: 'HTG', name: 'Gourde' };
                    this.form.cReceiver = 'HTG';
                } else if (this.form.country === 'DO') {
                    this.cReceiver[0] = { tm: 1, code: 'DOP', name: 'Pesos Dominicanos' };
                    this.form.cReceiver = 'DOP';
                } else if (this.form.country === 'PE') {
                    this.cReceiver[0] = { tm: 1, code: 'PEN', name: 'Nuevos Soles' };
                    this.form.cReceiver = 'PEN';
                } else if (this.form.country === 'VE') {
                    this.cReceiver[0] = { tm: 1, code: 'VES', name: 'Bolivares' };
                    this.form.cReceiver = 'VES';
                } else {
                    this.form.cReceiver = 'EUR';
                }

                this.cReceiver[1] = { tm: 2, code: 'USD', name: 'Dolares' };
            } else {
                this.cReceiver = [{ tm: 1, code: 'USD', name: 'Dolares' }];
                this.form.cReceiver = 'USD';
            }
        },
        getIni() {
            this.loading = true;
            this.getBanks();
            this.getOffices();
            this.getWallets();
            console.log(`PARTNER:`, this.user)
        },
        getWallets() {
            this.wallets = [];
            let country = this.form.country;
            const base = this.server || '';
            axios.get(`${base}/api/partner/wallets/${country}`).then((res) => {
                this.wallets = res.data || [];
                this.payReceivers[2].disabled = this.wallets.length === 0;
                if (this.wallets.length === 0 && this.form.payReceiver === 'Wallet') {
                    this.form.payReceiver = 'Bank';
                    this.walletSelected = null;
                    if (this.banks.length > 0) this.bankSelected = this.banks[0];
                } else if (this.form.payReceiver === 'Wallet' && this.walletSelected === null && this.wallets.length > 0) {
                    this.walletSelected = this.wallets[0];
                }
            }).catch(err => {
                this.wallets = [];
                this.payReceivers[2].disabled = true;
                if (this.form.payReceiver === 'Wallet') {
                    this.form.payReceiver = 'Bank';
                    this.walletSelected = null;
                }
                this.$root.$bvToast.toast(err.response?.data?.errors || 'Error al cargar wallets', {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getBanks() {
            this.banks = [];
            let country = this.form.country;
            axios.get('/api/customer/' + country + '/banks').then((res) => {
                if (this.form.payReceiver === 'Bank' && this.bankSelected === null) {
                    this.bankSelected = res.data.banks[0];
                }
                this.banks = res.data.banks;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getOffices() {
            this.offices = [];
            let country = this.form.country;
            axios.get('/api/customer/' + country + '/offices').then((res) => {
                let offices = res.data.offices;
                for (let i = 0; i < offices.length; i++) {
                    offices[i].name = offices[i].payer + ' - ' + offices[i].name + ' - ' + offices[i].city;
                }
                this.offices = offices;
                if ((this.offices).length > 0) {
                    this.payReceivers[1].disabled = (this.form.country === 'BR' || this.form.country === 'VE');
                    if (this.form.payReceiver === 'Cash' && this.officeSelected === null) {
                        this.officeSelected = res.data.offices[0];
                    }
                } else {
                    if (this.form.payReceiver === 'Cash') {
                        this.form.payReceiver = 'Bank';
                        this.officeSelected = null;
                    }
                    this.payReceivers[1].disabled = true;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        getData() {
            if (this.form.payReceiver === 'Wallet' && this.wallets.length === 0) return;
            this.loading = true;
            let send = this.form.local;
            let receiver = this.form.country;
            let payer = this.form.payer ? this.form.payer : 0;
            let payer_id = this.form.payer_id ? this.form.payer_id : 0;
            const base = this.server || '';
            axios.get(`${base}/api/partner/request/settings/${payer}/${payer_id}/${send}/${receiver}`).then((res) => {
                if (res.data.status === 'success') {
                    this.collections = res.data.currencies;
                    this.minData = res.data.min;
                    this.maxData = res.data.max;
                    this.feeData = res.data.fee;
                    this.getRCurrency((res.data.currencies).length);

                    let fee = 0;
                    let decimals = 2;
                    let feeData = this.feeData;
                    let min = this.minData.data.value;
                    let max = this.maxData.data.value;
                    let collections = this.collections;
                    if (feeData) {
                        for (let u = 0; u < feeData.length; u++) {
                            if (min > feeData[u].data.min && min <= feeData[u].data.max &&
                                payer === feeData[u].data.payer) {
                                let fc = 0;
                                let ft = feeData[u].item;
                                let fv = feeData[u].data.value;
                                let ftc = feeData[u].data.tc;
                                let fvc = feeData[u].data.com;

                                if (ft === '%') {
                                    if (ftc === '%') {
                                        fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                        fee = (min / 100) * fc;
                                    } else {
                                        fee = (min / 100) * fv;
                                        fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                    }
                                } else if (ft === '=') {
                                    fc = fvc;
                                    if (ftc === '%') {
                                        fc = (min / 100) * fv;
                                    }
                                    fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                                }
                            }
                        }
                        min = min + fee;
                    }
                    for (let i = 0; i < collections.length; i++) {
                        if (collections[i].code_send === this.form.cSend &&
                            collections[i].country_send === this.form.local) {
                            if (this.form.cSend !== 'USD') {
                                decimals = 0;
                                min = min / collections[i].value;
                                max = max / collections[i].value;
                            }
                        }
                    }
                    this.min = parseFloat(min.toFixed(decimals));
                    this.max = parseFloat(max.toFixed(decimals));
                    this.form.vSend = parseFloat(min.toFixed(decimals));
                    this.precision = decimals;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.getFx();
                console.log(`PARTNER:`, this.user)
            });
            this.timeout = setTimeout(this.getData, 300000);
        },
        getFx() {
            let fx = 1;
            let fx_rate = 1;
            let decimals = 2;
            let payer = this.form.payer;
            let cSend = this.form.cSend;
            let cReceiver = this.form.cReceiver;
            let collections = this.collections;
            let min = this.minData.data.value;
            let max = this.maxData.data.value;
            if (this.feeData) {
                let fee = 0;
                let feeData = this.feeData;
                for (let u = 0; u < feeData.length; u++) {
                    if (min > feeData[u].data.min && min <= feeData[u].data.max && payer === feeData[u].data.payer) {
                        let fc = 0;
                        let ft = feeData[u].item;
                        let fv = feeData[u].data.value;
                        let ftc = feeData[u].data.tc;
                        let fvc = feeData[u].data.com;

                        if (ft === '%') {
                            if (ftc === '%') {
                                fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                fee = (min / 100) * fc;
                            } else {
                                fee = (min / 100) * fv;
                                fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                            }
                        } else if (ft === '=') {
                            fc = fvc;
                            if (ftc === '%') {
                                fc = (min / 100) * fv;
                            }
                            fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                        }
                    }
                }
                min = min + fee;
            }
            if (cSend !== cReceiver) {
                for (let i = 0; i < collections.length; i++) {
                    if (collections[i].code_send === cSend &&
                        collections[i].country_send === this.form.local) {
                        if (collections[i].code_send !== 'USD') {
                            decimals = 0;
                            min = min / collections[i].value;
                            max = max / collections[i].value;
                            fx = collections[i].value;
                        }
                        fx_rate = collections[i].value;
                    } else if (collections[i].code_receiver === cReceiver) {
                        fx_rate = fx_rate * collections[i].value;
                    }
                }
            }
            this.fx = fx;
            this.min = parseFloat(min.toFixed(decimals));
            this.max = parseFloat(max.toFixed(decimals));
            this.form.convert = fx_rate;
            this.precision = decimals;
            this.getResult();
        },
        getResult(n) {
            let fee = 0;
            let fx = this.fx;
            let feeData = this.feeData;
            let payer = this.form.payer;
            let cv = this.form.convert;
            let ft = '%';
            let fv = 0;
            let ftc = '%';
            let fvc = 0;

            if (n) {
                let vReceiver = this.form.vReceiver;
                let vSend = vReceiver / cv;
                for (let u = 0; u < feeData.length; u++) {
                    let value = vSend * this.fx;
                    let fmin = feeData[u].data.min;
                    let fmax = feeData[u].data.max;
                    let fpayer = feeData[u].data.payer;
                    if (value > fmin && value <= fmax && payer === fpayer) {
                        let fc = 0;
                        ft = feeData[u].item;
                        fv = feeData[u].data.value;
                        ftc = feeData[u].data.tc;
                        fvc = feeData[u].data.com;

                        if (ft === '%') {
                            if (ftc === '%') {
                                fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                fee = (value / 100) * fc;
                            } else {
                                fee = (value / 100) * fv;
                                fee = ((fee - fvc) * (1 + feeData[u].data.tax)) + fvc;
                            }
                        } else if (ft === '=') {
                            fc = fvc;
                            if (ftc === '%') {
                                fc = (value / 100) * fc;
                            }
                            fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                        }
                        this.fee = parseFloat((fee / fx).toFixed(2));
                        this.form.vSend = vSend + (fee / fx);
                    }
                }

                if (Math.round(vSend + (fee / fx)) < Math.round(this.min)) {
                    this.msg = 'minimo';
                } else if (Math.round(vSend + (fee / fx)) > Math.round(this.max)) {
                    this.msg = 'maximo';
                } else {
                    this.msg = null;
                }
            } else {
                let vSend = this.form.vSend;
                for (let u = 0; u < feeData.length; u++) {
                    let value = vSend * this.fx;
                    let fmin = feeData[u].data.min;
                    let fmax = feeData[u].data.max;
                    let fpayer = feeData[u].data.payer;
                    if (value > fmin && value <= fmax && payer === fpayer) {
                        let fc = 0;
                        ft = feeData[u].item;
                        fv = feeData[u].data.value;
                        ftc = feeData[u].data.tc;
                        fvc = feeData[u].data.com;

                        if (ft === '%') {
                            if (ftc === '%') {
                                fc = ((fv - fvc) * (1 + feeData[u].data.tax)) + fvc;
                                fee = value - (value / (1 + (0.01 * fc)));
                            } else {
                                fc = fvc;
                                fv = fv * (1 + feeData[u].data.tax);
                                fee = value - (value / (1 + (0.01 * fv)));
                                fee = fee - ((fc * feeData[u].data.tax) / (1 + (0.01 * fv)));
                            }
                        } else if (ft === '=') {
                            fc = fvc;
                            if (ftc === '%') {
                                fee = value - (value / (1 + (0.01 * fc)));
                            }
                            fee = ((fv - fc) * (1 + feeData[u].data.tax)) + fc;
                        }
                        this.fee = parseFloat((fee / fx).toFixed(2));
                        this.form.vReceiver = (vSend - (fee / fx)) * cv;
                    }
                }

                if (Math.round(vSend) < Math.round(this.min)) {
                    this.msg = 'minimo';
                } else if (Math.round(vSend) > Math.round(this.max)) {
                    this.msg = 'maximo';
                } else {
                    this.msg = null;
                }
            }
            this.loading = false;

            // Si el payer es TERRAPAY, consultar la API para obtener el monto real
            if (this.form.payer === 'TERRAPAY' && this.form.vSend > 0 && !this.msg) {
                this.debouncedQuoteTerrapay(n ? 'receiver' : 'sender');
            }
        },
        debouncedQuoteTerrapay(mode) {
            clearTimeout(this.quoteTimeout);
            this.quoteTimeout = setTimeout(() => {
                this.fetchTerrapayQuote(mode);
            }, 1000);
        },
        fetchTerrapayQuote(mode) {
            const vSend = this.form.vSend;
            const feeAmount = this.fee;
            const valorConvertir = vSend - feeAmount;
            if (valorConvertir <= 0) return;

            this.quotingTerrapay = true;
            const base = this.server || '';
            const country = this.form.country;
            const currency = this.form.cReceiver;
            axios.get(`${base}/api/partner/request/quote-terrapay/${country}/${currency}/${valorConvertir}`)
                .then((res) => {
                    if (res.data.status === 'success' && res.data.receivingAmount != null) {
                        const realAmount = res.data.receivingAmount;

                        if (mode === 'receiver') {
                            // Agente escribió el monto que quiere que reciba el beneficiario
                            // Solo actualizar la tasa de cambio con la de Terrapay
                            // El backend se encarga de pedir el monto exacto a Terrapay
                            if (realAmount > 0 && valorConvertir > 0) {
                                this.form.convert = realAmount / valorConvertir;
                            }
                        } else {
                            // Agente escribió CLP — mostrar el monto real que recibe el beneficiario
                            this.form.vReceiver = realAmount;
                            if (realAmount > 0 && valorConvertir > 0) {
                                this.form.convert = realAmount / valorConvertir;
                            }
                        }
                    }
                })
                .catch((err) => {
                    console.error('Error cotizando Terrapay:', err);
                })
                .finally(() => {
                    this.quotingTerrapay = false;
                });
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
        clearTimeout(this.quoteTimeout);
    }
}
</script>

<style scoped></style>
